import { OfferingStatus } from "@/models/OfferingStatus"
import { OfferingType } from "@/models/OfferingType"
import { Price } from "@/models/Price"
import { QRCode } from "@/models/QRCode"
import type { JSONSchemaType } from "ajv"
import { PostPurchase } from "@/models/postPurchase"
import { UserPreview } from "@/models/userPreview"

export interface Offering {
  name: string
  description?: string
  offeringID: string
  userID: string
  status: OfferingStatus
  hidden: boolean
  defaultPriceID?: string
  userPreview: UserPreview
  pricing: Price[]
  type: OfferingType
  storeOrder?: number
  publicURL?: string
  sharingURL?: string
  sharingQRCode: QRCode
  // urlsLastUpdated?: string
  postPurchase?: PostPurchase
}

export function defaultPrice(offering: Offering): Price {
  if (offering.defaultPriceID) {
    return offering.pricing.find(
      (price) => price.id === offering.defaultPriceID,
    )!
  }

  return (
    offering.pricing.find((price) => price.id === "base") ??
    offering.pricing.find((price) => !price.hidden)!
  )
}

export const schema: JSONSchemaType<Offering> = {
  $id: "https://newie.app/schemas/offering.json",
  type: "object",
  properties: {
    name: { type: "string" },
    description: { type: "string", nullable: true },
    offeringID: { type: "string" },
    userID: { type: "string" },
    status: {
      type: "string",
      enum: ["active", "pending", "draft", "archived"],
    },
    hidden: { type: "boolean" },
    defaultPriceID: { type: "string", nullable: true },
    type: { type: "string", enum: ["SUBSCRIPTION", "PURCHASE"] },
    storeOrder: { type: "number", nullable: true },
    publicURL: { type: "string", nullable: true },
    userPreview: { $ref: "https://newie.app/schemas/userPreview.json" },
    sharingURL: { type: "string", nullable: true },
    pricing: {
      type: "array",
      items: { $ref: "https://newie.app/schemas/price.json" },
    } as unknown as any,
    sharingQRCode: {
      type: "object",
      properties: {
        URL: { type: "string" },
      },
      required: ["URL"],
    },
    // TODO:KB 23/10/2024 this should be a timestamp
    // it is not used so currently commenting it out to prevent the validation error
    // urlsLastUpdated: { type: "string", nullable: true },
    postPurchase: { $ref: "https://newie.app/schemas/postPurchase.json" },
  },
  required: [
    "name",
    "offeringID",
    "userID",
    "status",
    "hidden",
    "type",
    "sharingQRCode",
    "pricing",
    "userPreview",
  ],
}
